import styled from "styled-components";

const  Button = styled.div`
    font-size: 16px;
    background: #13c791;
    border: none;
    height: 30px;
    width: 96px;
    line-height: 30px;
    border-radius: 10px;
    text-align: center;
  `

  export default Button